<ng-container *ngIf="count <= nzOverflowCount; else overflowTemplate">
  <span class="ant-scroll-number-only">
    <ng-container *ngIf="!nzDot && count !== undefined">
      <p class="ant-scroll-number-only-unit">
        {{ count }}
      </p>
    </ng-container>
    <ng-container *ngIf="nzDot && count > nzOverflowCount">
      <p class="ant-scroll-number-only-unit ant-scroll-number-dot">+</p>
    </ng-container>
  </span>
</ng-container>
<ng-template #overflowTemplate>{{ nzOverflowCount }}+</ng-template>
